var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatchLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 60,
    width: 266.25,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M145.434 16.114c-3.023-4.756-8.202-7.596-13.854-7.596-9.027 0-16.371 7.289-16.371 16.25 0 8.959 7.344 16.247 16.371 16.247 5.608 0 10.766-2.806 13.796-7.506l.408-.633 5.146 3.23-.412.64c-4.156 6.457-11.235 10.313-18.938 10.313-12.384 0-22.461-10-22.461-22.292 0-12.292 10.077-22.293 22.461-22.293 7.75 0 14.853 3.892 19 10.409l.407.64-5.146 3.231-.407-.64z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-837-63H288v2001H-837V-63z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M6.211 47.051H.001V2.482h30.252v6.174H6.21V47.05z"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-837-63H288v2001H-837V-63z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M37.175 2.468h43.951v44.621H37.175V2.468z"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-837-63H288v2001H-837V-63z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 2h45v46H37V2Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M56.858 47.089 37.175 2.467h6.8l15.184 34.357L74.334 2.467h6.792L61.388 47.09h-4.53z"
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 2h45v46H37V2Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M108.102 47.051H74.245v-6.175h13.802V2.482h6.203v38.394h13.852v6.175z"
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-837-63H288v2001H-837V-63z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M186.799 27.863h-23.933v19.198h-6.207V2.48h6.207v19.218H186.8V2.472h6.205V47.06H186.8V27.863z"
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-837-63H288v2001H-837V-63z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M211.64 37.657v10.239h-10.284V37.657h10.284z"
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-837-63H288v2001H-837V-63z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 37h11v11h-11V37z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    d: "M206.667 42.985c.487 0 .73.04.934.135.282.119.459.401.459.777 0 .35-.19.632-.46.751-.216.093-.446.122-.933.122h-1.34v-1.785h1.34zm-1.34-2.898h-.688v5.34h2.203c.717 0 1.082-.134 1.393-.349.392-.282.582-.697.582-1.181 0-.912-.718-1.461-1.448-1.557l1.623-2.253h-.88l-1.634 2.24h-1.15v-2.24zm1.162 7.195c-2.5 0-4.407-2.033-4.407-4.514 0-2.45 1.907-4.466 4.407-4.466 2.533 0 4.439 2.017 4.439 4.466 0 2.481-1.906 4.514-4.439 4.514zm0-9.625c-2.898 0-5.134 2.25-5.134 5.113 0 2.892 2.236 5.126 5.134 5.126 2.932 0 5.152-2.234 5.152-5.126 0-2.864-2.22-5.113-5.152-5.113z"
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 37h11v11h-11V37z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M94.119 62.059h71.868v-74.585H94.119v74.585z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.25 0 0 -1.25 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M-15 62.051h60.253v-74.569H-15v74.57z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.25 0 0 -1.25 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M22.175 62.089h73.951v-74.622H22.175V62.09z"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.25 0 0 -1.25 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M59.245 62.051h63.857v-74.569H59.245v74.57z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.25 0 0 -1.25 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M141.659 62.06h66.345v-74.588H141.66V62.06z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.25 0 0 -1.25 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M186.356 62.896h40.285V22.657h-40.285v40.239z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatchLogo);
export default __webpack_public_path__ + "static/media/latch-logo.14a01b853df17eb15ce53a9a5f08d4dc.svg";
export { ForwardRef as ReactComponent };